import React from 'react'
import { History } from 'history'
import { WemoloChip } from '../../../components/Wemolo'
import { AccessControlDevice } from '../../../views/AccessControl'
import styles from './lotUtils.module.css'

export const getAccessControlDeviceTableRow = (acDevice: AccessControlDevice, history: History) => {
    const handleDeviceClick = () => {
        history.push(`/AC?deviceId=${acDevice.device_id}`)
    }

    return {
        stationName: '-',
        deviceId: (
            <div onClick={handleDeviceClick} className={styles.deviceLink}>
                {acDevice.device ? `${acDevice.device} (${acDevice.device_id})` : acDevice.device_id || '-'}
            </div>
        ),
        onlineStatus: '-',
        deviceConfigStatus: '-',
        links: '-',
        extra: (
            <div className={styles.chipGroup}>
                {acDevice.device_type ? <WemoloChip selected label={acDevice.device_type} /> : '-'}
                {acDevice.lp_access_station_mapping && (
                    <WemoloChip selected label={acDevice.lp_access_station_mapping} />
                )}
            </div>
        )
    }
}
